<template>
  <div v-editable="blok" :class="$style['rich-text']">
    <StoryblokRichText :document="blok.text" />
  </div>
</template>
<script setup>
defineProps({ blok: Object })
</script>
<style module>
/* Running text on the stage: a comfortable measure, poster headings, amber links and list markers.
   Links with a class are buttons that Storyblok places in the text; they keep their own colours. */
.rich-text {
  font-size: var(--stage-text);
  line-height: 1.7;
  color: var(--stage-copy);
}

.rich-text > :where(p, ul, ol, blockquote, h2, h3, h4) {
  max-width: var(--stage-measure);
}

.rich-text :where(p) {
  margin: 0 0 1em;
  font-size: inherit;
}

/* One rhythm between sections, whatever size the heading is */
.rich-text :where(h2) {
  margin: var(--stage-rhythm) 0 0.5em;
  color: var(--stage-white);
}

.rich-text :where(h3, h4) {
  margin: calc(var(--stage-rhythm) * 0.6) 0 0.5em;
  color: var(--stage-white);
}

/* A title in the text itself (a page without a photo): big, but not a poster */
.rich-text :where(h1) {
  margin: 0 0 0.45em;
  font-size: var(--stage-title-long);
  color: var(--stage-white);
}

/* The opening paragraph leads in a size up */
.rich-text > :where(p:first-child:not(:only-child), h1 + p) {
  font-size: 1.2em;
  line-height: 1.55;
  color: var(--stage-white);
}

.rich-text > :where(:first-child) {
  margin-top: 0;
}

.rich-text :where(a:not([class])) {
  color: var(--primary-color);
  text-decoration-thickness: 0.08em;
  text-underline-offset: 0.2em;
}

.rich-text :where(a:not([class]):hover) {
  color: var(--stage-white);
}

.rich-text :where(ul, ol) {
  display: flex;
  flex-direction: column;
  gap: 0.4em;
  margin: 0 0 1.5em;
  padding-left: 1.25em;
}

.rich-text :where(li)::marker {
  color: var(--primary-color);
}

.rich-text :where(li p) {
  margin: 0;
}

.rich-text :where(b, strong) {
  color: var(--stage-white);
}

.rich-text :where(blockquote) {
  margin: 1.5em 0;
  padding-left: var(--spacing-xl);
  border-left: 0.25rem solid var(--primary-color);
  font-size: 1.25em;
}
</style>
